module.exports = __webpack_public_path__ + "static/media/image.8f225850.png";